export const getContextTypes = (requestedContextTypesRules, cardinality) => {
    const contextTypes = [];
    for (const requestedContextTypesRule of requestedContextTypesRules !== null && requestedContextTypesRules !== void 0 ? requestedContextTypesRules : []) {
        if (cardinality !== undefined && cardinality !== requestedContextTypesRule.cardinality) {
            continue;
        }
        for (const type of requestedContextTypesRule.contextTypes) {
            contextTypes.push([type, requestedContextTypesRule.cardinality]);
        }
    }
    return contextTypes;
};
//# sourceMappingURL=requested-contexts-util.js.map